import script from "./RecommendList.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecommendList.vue?vue&type=script&lang=ts&setup=true"

import "./RecommendList.vue?vue&type=style&index=0&id=67b9a504&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b9a504"]])

export default __exports__